<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button defaultHref="/leagues"></ion-back-button>
        </ion-buttons>
        <ion-item lines="none" color="none">
            <ion-label class="ion-text-wrap">{{ league?.name }}</ion-label>
        </ion-item>
        <ion-buttons slot="end">
            <!-- <ion-button (click)="upload.click()">
                <ion-icon slot="icon-only" name="cloud-upload"></ion-icon>
            </ion-button> -->
            <app-share-match [leagueShortUrl]="league?.urlSegment" [position]="'header'"></app-share-match>

            @if (authService.authUserSignal()) {
                <ion-button (click)="changeFollow()">
                    @if (!canFollow) {
                        <ion-icon slot="icon-only" name="notifications"></ion-icon>
                    } @else {
                        <ion-icon slot="icon-only" name="notifications-outline"></ion-icon>
                    }
                </ion-button>
    
                @if (isOwner) {
                    <ion-button (click)="openLeagueOptions($event)">
                        <ion-icon slot="icon-only" name="ellipsis-vertical"></ion-icon>
                    </ion-button>
                }
            }
        </ion-buttons>
    </ion-toolbar>
    <ion-toolbar>
        <ion-segment value="ties" #segment class="content-width">
            <ion-segment-button value="ties">
                <ion-label>{{ 'Matches' | translate }}</ion-label>
            </ion-segment-button>
            @if (authService.authUserSignal()?.role.value > 499 || league?.settings.draw.enabled) {
                <ion-segment-button value="draw">
                    <ion-label>{{ 'Draw' | translate }}</ion-label>
                </ion-segment-button>
            }
            <ion-segment-button value="teams">
                <ion-label>{{ 'Teams' | translate }}</ion-label>
            </ion-segment-button>
        </ion-segment>
    </ion-toolbar>
</ion-header>

<ion-content>
    @defer (when isLoading === false) {
        <ion-refresher (ionRefresh)="getLeague($event)" slot="fixed">
            <ion-refresher-content></ion-refresher-content>
        </ion-refresher>
    
        @if (segment.value === 'ties') {
            @if (!league.ties.length) {
                <app-empty-page [text]="noTeamMatchesText" iconName="tennisball"></app-empty-page>
            } @else {
                <ion-list class="content-width">
                    @for (tie of league?.ties; track $index) {
                        <app-tie-scorecard [tie]="tie" [isListView]="true"></app-tie-scorecard>
                    }
                </ion-list>
            }
            @if (isOwner && (authService.authUserSignal().role.value > 399 || league.organisation?.organisationAbbreviation !== 'ITA')) {
                <ion-fab vertical="bottom" horizontal="end" slot="fixed">
                    <ion-fab-button color="primary" (click)="addTie()">
                        <ion-icon name="add"></ion-icon>
                    </ion-fab-button>
                </ion-fab>
            }
        } @else if (segment.value === 'draw') {
            <app-league-draw [ties]="league.ties"></app-league-draw>
        }  
        @else {
            @if (!league.teams.length) {
                <app-empty-page class="content-width" [text]="noTeamsText" iconName="people"></app-empty-page>
            } @else {
                <ion-list class="content-width">
                    @for (team of league.teams; track team._id; let i = $index) {
                        <app-team-item [showRemoveTeam]="showRemoveTeam" [team]="team" (click)="navigateToTeamDetailsPage(team)" (removeTeam)="removeTeamFromLeague(team._id, i)"></app-team-item>
                    }
                </ion-list>
            }

            @if (isOwner) {
                <ion-fab vertical="bottom" horizontal="end" slot="fixed">
                    <ion-fab-button color="primary" (click)="addTeam()">
                        <ion-icon name="add"></ion-icon>
                    </ion-fab-button>
                </ion-fab>
            }
            
        }    
    } @loading (minimum 0.6s) {
        @for (x of [0, 1, 2]; track $index) {
            <div class="ion-padding content-width">
                <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
                <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
                <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
                <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
                <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
                <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
            </div>
        }
    }
    
</ion-content>

@if (segment.value === 'teams' && isOwner) {
    <app-create-team-fab #createTeam hidden [leagueId]="leagueId" (team)="league.teams.unshift($event)"></app-create-team-fab>
}